import React, { FC, useState } from 'react';
import axios from 'axios';
import * as Sentry from '@sentry/react';
import { SentryTestAPI } from '../../constants/API';
import { isSentryEnabled, sentryEnvironmentName } from '../../instrument';
import classes from './SentryTestPage.module.scss';

const SentryTestPage: FC = () => {
  const [shouldCrashRender, setShouldCrashRender] = useState(false);
  const [sentMessage, setSentMessage] = useState('');

  if (shouldCrashRender) {
    throw new Error('Sentry test: render error');
  }

  const handleEventError = () => {
    throw new Error('Sentry test: event handler error');
  };

  const handleCaptureException = () => {
    Sentry.captureException(new Error('Sentry test: captureException'));
    setSentMessage('Событие отправлено без падения страницы. Проверьте Issues в Sentry.');
  };

  const handleApi500 = async () => {
    setSentMessage('');
    try {
      await axios.get(SentryTestAPI.triggerServerError);
    } catch {
      setSentMessage(
        'Запрос вернул 500. Фронт — проект eline_2_5_front, бэкенд — eline_2_5_back.'
      );
    }
  };

  return (
    <div className={classes.page}>
      <div className={classes.card}>
        <h1 className={classes.title}>Тест Sentry</h1>
        <p className={classes.status}>
          SDK: {isSentryEnabled ? 'включён' : 'выключен (нет DSN)'}
          {isSentryEnabled ? ` · окружение: ${sentryEnvironmentName}` : ''}
        </p>
        {!isSentryEnabled && (
          <p className={classes.hint}>
            Задайте REACT_APP_SENTRY_DSN в frontend/.env и перезапустите npm start.
          </p>
        )}

        <div className={classes.actions}>
          <button type="button" className={classes.button} onClick={handleEventError}>
            Ошибка в обработчике
          </button>
          <button type="button" className={classes.button} onClick={() => setShouldCrashRender(true)}>
            Ошибка рендера
          </button>
          <button type="button" className={classes.buttonSecondary} onClick={handleCaptureException}>
            Отправить без падения
          </button>
          <button type="button" className={classes.button} onClick={handleApi500}>
            Ошибка API 500
          </button>
        </div>

        {sentMessage && <p className={classes.hint}>{sentMessage}</p>}

        <ul className={classes.notes}>
          <li>
            <strong>Ошибка в обработчике</strong> — необработанное исключение. Смотрите Issues.
          </li>
          <li>
            <strong>Ошибка рендера</strong> — ErrorBoundary, экран «Произошла ошибка». Смотрите
            Issues.
          </li>
          <li>
            <strong>Отправить без падения</strong> — captureException, страница остаётся на месте.
          </li>
          <li>
            <strong>Ошибка API 500</strong> — бэкенд бросает исключение. Два Issue: eline_2_5_front и
            eline_2_5_back.
          </li>
        </ul>
      </div>
    </div>
  );
};

export default SentryTestPage;
